const orderTypeMap = {
  COMMON_WITH_HOLD: "普通代扣服务费流水",
  DEFAULT_WITH_HOLD: "违约代扣服务费流水",
  SHARE_SESAME_SERVICE_WITH_HOLD: "共享充电技术服务流水(芝麻先享)",
  SHARE_SESAME_CLEAR_OWNER: "共享桩主分账流水(芝麻先享)",
  SHARE_PREPAY: "共享充电预付流水",
  SHARE_REFUND: "共享充电退款流水",
  SHARE_CLEAR_OWNER: "共享桩主分账流水",
  ACTIVITY_PAYOUT: "活动桩买断支付流水",
  ACTIVITY_REFUND: "活动桩退出支付流水",
  ACTIVITY_DEFAULT: "活动桩违约支付流水",
  ACTIVITY_JOIN: "活动桩参加活动支付流水",
  MONTH_DATA_PAY: "月度流量支付",
  MONTH_DATA_WITH_HOLD: "月度流量代扣",
  NEW_499_PAY_ORDER: "新499活动-用桩服务",
  NEW_499_BUYOUT_ORDER: "新499活动-买断服务",
  NEW_499_REFUND_ORDER: "新499活动-退出服务",
};

let pageConfig = {};

pageConfig.listColumns = [
  {
    label: "购买订单编号",
    props: "mapNo",
    minWidth: 220,
  },
  {
    label: "订单状态",
    props: "orderStatusName",
    minWidth: 220,
  },
  {
    label: "用户手机号",
    props: "mobile",
    minWidth: 150,
  },
  {
    label: "购买名称",
    props: "orderName",
    minWidth: 190,
    // formatter: (row) => {
    //   return orderTypeMap[row.orderType] || row.orderType || "--";
    // },
  },
  {
    label: "购买内容",
    props: "orderDetail",
    minWidth: 260,
    formatter: (row) => {
      return row.orderDetail || "守护者7KW4G联网版;30米内上门安装";
    },
  },
  {
    label: "实收金额（元）",
    props: "actualAmount",
    minWidth: 150,
  },
  {
    label: "累计实收流量服务费（元）",
    props: "actualAmountTotal",
    minWidth: 190,
  },
  {
    label: "购买时间",
    props: "purchaseTime",
    minWidth: 180,
  },
  {
    label: "支付方式",
    props: "deductionWay",
    minWidth: 120,
    formatter: (row) => {
      if (row.deductionWay === "ALIPAY") {
        return "支付宝";
      }
      if (row.deductionWay === "SYSTEM_GIFT") {
        return "系统赠送";
      }
      return row.deductionWay || "--";
    },
  },
  {
    label: "交易流水号",
    props: "transactionNo",
    minWidth: 240,
  },
  {
    label: "退款申请时间",
    props: "refundFromTime",
    minWidth: 170,
  },
  {
    label: "退款操作时间",
    props: "refundOperationTime",
    minWidth: 180,
  },
  {
    label: "退款完成时间",
    props: "refundAccomplishTime",
    minWidth: 180,
  },
  {
    label: "退款金额（元）",
    props: "refundAmount",
    minWidth: 150,
  },
  {
    label: "退款原因",
    props: "refundReason",
    minWidth: 180,
  },
  {
    label: "退款原因备注",
    props: "refundReasonRemark",
    minWidth: 200,
  },
  {
    label: "退款类型",
    props: "refundType",
    minWidth: 120,
    formatter: (row) => {
      if (row.refundType === "ALL") return "全额退款";
      if (row.refundType === "PART") return "部分退款";
      if (row.refundType === "REJECT") return "拒绝退款";
      return row.refundType || "--";
    },
  },
  {
    label: "退款方式",
    props: "refundWay",
    minWidth: 120,
    formatter: (row) => {
      if (row.refundWay === "FREE") return "芝麻免押";
      if (row.refundWay === "MANUAL") return "手动退款";
      if (row.refundWay === "AUTO") return "自动退款";
      return row.refundWay || "--";
    },
  },
  {
    label: "是否恢复服务使用",
    props: "resetUse",
    minWidth: 150,
    formatter: (row) => {
      if (row.resetUse === "Y") return "是";
      if (row.resetUse === "N") return "否";
      return row.resetUse || "--";
    },
  },
  {
    label: "退款状态",
    props: "refundResult",
    minWidth: 120,
    formatter: (row) => {
      if (row.refundResult === "TO_REFUND") return "待退款";
      if (row.refundResult === "REFUNDED") return "已退款";
      if (row.refundResult === "SUCCESS") return "成功";
      if (row.refundResult) return "失败";
      return "--";
    },
  },
  {
    label: "退款操作人",
    props: "refundByName",
    minWidth: 140,
  },
  {
    label: "钱包编号",
    props: "walletNo",
    minWidth: 180,
  },
];

pageConfig.listBreadCrumb = [
  {
    type: "title",
    name: "首页",
  },
  {
    type: "title",
    name: "营销活动",
  },
  {
    type: "title",
    name: "安心包598活动",
  },
  {
    type: "title",
    name: "安心包598商品订单",
  },
];

pageConfig.tableConfig = {
  showSelection: true,
  showIndex: false,
};

pageConfig.pagination = {
  current: 1,
  total: 0,
  pageSize: 10,
  pageSizes: [10, 20, 50, 100],
};

pageConfig.orderTypeMap = orderTypeMap;

export default pageConfig;

